<button (click)="share()" [disabled]="disabled" color="accent" mat-icon-button>
    <mat-icon>{{ isIos ? "ios_share" : "share" }}</mat-icon>
</button>
